import { m8API } from 'services/production/m8';
import {
  HTTPConnectionError,
  AdminSiteIsNotRespondingError,
  OutOfResourcesError,
  UnauthorizedError,
  ForbiddenError,
} from 'utils/errors';

export const customFetch = (
  url: RequestInfo,
  params?: RequestInit,
  shouldRefreshToken: boolean = true
): Promise<Response> => {
  return fetch(url, params)
    .catch(() => {
      throw new HTTPConnectionError();
    })
    .then((response) => {
      if (response.status === 401) {
        if (shouldRefreshToken) {
          return m8API.auth.refreshToken().then(() => {
            return customFetch(url, params, false);
          });
        }

        throw new UnauthorizedError();
      }

      if (response.status === 403) {
        throw new ForbiddenError();
      }

      if (response.status === 503) {
        throw new AdminSiteIsNotRespondingError();
      }

      if (response.status === 507 || response.status === 509) {
        throw new OutOfResourcesError();
      }

      return response;
    });
};

export const appendHeadersWithJSONContentType = (headers: Headers) => {
  headers.append('Content-Type', 'application/json');
};

type ValueType = string | number | boolean | undefined | File;

export const appendFormDataWithObjectValues = (
  formData: FormData,
  object: { [key: string]: ValueType | ValueType[] }
): void => {
  const appendValue = (field: string, value: ValueType) => {
    if (value instanceof File) {
      formData.append(field, value, value.name);
    } else if (typeof value === 'object') {
      formData.append(field, value);
    } else {
      formData.append(field, `${value}`);
    }
  };

  for (const field in object) {
    const value = object[field];

    if (value !== undefined) {
      if (Array.isArray(value)) {
        value.forEach((value) => {
          appendValue(field, value);
        });
      } else {
        appendValue(field, value);
      }
    }
  }
};
